import React from 'react';
import { ResponsiveImage } from './ResponsiveImage';
import { ArrowRight } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-serif text-gray-800 mb-12 text-center">
          Témoignages de nos clients et candidats
        </h2>

        <div className="grid md:grid-cols-3 gap-8 stagger-animation">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group hover-lift"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden img-zoom">
                <ResponsiveImage sizes="(min-width: 1280px) 384px, (min-width: 768px) 33vw, 100vw"
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <h3 className="font-semibold text-lg">{testimonial.name}</h3>
                  <p className="text-sm opacity-90">{testimonial.role}, {testimonial.company}</p>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 mb-4 line-clamp-4 leading-relaxed">
                  {testimonial.story}
                </p>
                <a 
                  href={testimonial.link}
                  className="inline-flex items-center gap-2 text-[#E30022] font-medium hover:underline group/link"
                >
                  En savoir plus
                  <ArrowRight className="h-4 w-4 group-hover/link:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
